import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

export default function ExternalRedirect({ url, fallback = '/' }) {
  // open the link once, after the component mounts
  useEffect(() => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }, [url]);

  // send the current tab somewhere harmless
  return <Navigate to={fallback} replace />;
}

ExternalRedirect.propTypes = {
  url: PropTypes.string.isRequired,
  fallback: PropTypes.string,
};
